<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";
import type { RouteLocationRaw } from "vue-router";
import LinkButton from "@/components/buttons/LinkButton.vue";
import PermissionTooltip from "@/components/tooltips/PermissionTooltip.vue";

const { t } = useI18n();

defineProps<{
  id: number;
  to: RouteLocationRaw;
}>();
</script>

<template>
  <permission-tooltip :permission="DispatcherPermissionValue.EditOrCreateCompany">
    <template #activator="{ disabled }">
      <link-button :to="to" variant="text">
        <v-icon :disabled="disabled" small>mdi-pencil</v-icon>
      </link-button>
    </template>

    {{ t("permission.edit-company") }}
  </permission-tooltip>
</template>
